import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
export default {
  name: "VxeTable",
  props: {
    isShowPager: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: ""
    },
    data: [Array],
    tableDataCount: {
      type: Object,
      default: function _default() {
        return {};
      } // default: {},
    },

    tableColumn: [Array]
  },
  created: function created() {
    this.init();
  },
  data: function data() {
    return {
      loading: false,
      showDetails: false,
      selectRow: null,
      isAllChecked: false,
      isIndeterminate: false,
      selectRecords: [],
      serverList: [],
      tablePage: {
        totalResult: 10,
        currentPage: 1,
        pageSize: 1000
      },
      tableData: [],
      tableToolbar: {
        custom: true,
        zoom: true,
        slots: {
          tools: "toolbar_tools",
          buttons: "toolbar_buttons"
        },
        export: true
      },
      exportConfig: {
        types: ["csv"],
        modes: ["current"] //['current', 'all']
      },

      scrollYConfig: {
        enabled: false
      }
    };
  },
  watch: {
    data: function data(newVal) {
      this.tablePage.totalResult = newVal.length;
      this.tableData = this.data.slice((this.tablePage.currentPage - 1) * this.tablePage.pageSize, this.tablePage.currentPage * this.tablePage.pageSize);
    }
  },
  methods: {
    init: function init() {},
    handlePageChange: function handlePageChange(_ref) {
      var currentPage = _ref.currentPage,
        pageSize = _ref.pageSize;
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.tableData = this.data.slice((this.tablePage.currentPage - 1) * this.tablePage.pageSize, this.tablePage.currentPage * this.tablePage.pageSize);
    },
    searchEvent: function searchEvent() {
      this.loadTatleData();
    },
    showDetailEvent: function showDetailEvent(row) {
      this.selectRow = row;
      this.showDetails = true;
    },
    addressClickEvent: function addressClickEvent(row) {
      this.$XModal.alert("address\u70B9\u51FB\u4E8B\u4EF6\uFF1A".concat(row.address));
    },
    changeFilterEvent: function changeFilterEvent(evnt, option, $panel) {
      $panel.changeOption(evnt, !!option.data, option);
    },
    checkboxChangeEvent: function checkboxChangeEvent(_ref2) {
      var records = _ref2.records;
      this.isAllChecked = this.$refs.xGrid.isAllCheckboxChecked();
      this.isIndeterminate = this.$refs.xGrid.isAllCheckboxIndeterminate();
      this.selectRecords = records;
    },
    changeAllEvent: function changeAllEvent() {
      this.$refs.xGrid.setAllCheckboxRow(this.isAllChecked);
      this.selectRecords = this.$refs.xGrid.getCheckboxRecords();
    },
    // 排序注释
    sortChangeEvent: function sortChangeEvent(e) {
      var fieldName = e.column.property;
      var sortingType = e.column.order;
      if (fieldName == "aaa") {
        if (sortingType == "desc") {
          this.tableColumn = this.tableColumn.sort(function (a, b) {
            return b[fieldName] - a[fieldName];
          });
          console.log(111, this.tableColumn);
        } else {
          this.tableColumn = this.tableColumn.sort(function (a, b) {
            return a[fieldName] - b[fieldName];
          });
        }
      }
    },
    footerMethod: function footerMethod(_ref3) {
      var _this = this;
      var columns = _ref3.columns;
      //data
      if (Object.keys(this.tableDataCount).length == 0) {
        return [];
      }
      return [columns.map(function (column, columnIndex) {
        if (columnIndex == 0) {
          return "\u5408\u8BA1\uFF08".concat(_this.data.length, "\uFF09");
        }
        if (column.property == 'open_time_str') {
          return '';
        }
        if (column.property == "new_role_pay_money") {
          return _this.tableDataCount[column.property] + "元" + "（" + _this.tableDataCount["new_role_arppu"] + "）";
        }
        if (column.property == "new_role_pay") {
          return _this.tableDataCount[column.property] + "（" + _this.tableDataCount["new_role_pay_rate"] + "%）";
        }
        if (column.property == "pay_money") {
          return _this.tableDataCount[column.property] + "元" + "（" + _this.tableDataCount["pay_arppu"] + "）";
        }
        if (column.property == "pay_role") {
          return _this.tableDataCount[column.property] + "（" + _this.tableDataCount["pay_rate"] + "%）";
        }
        if (column.property == "roll_money") {
          return _this.tableDataCount[column.property] + "元";
        }
        if (column.property == "keep_role_1_day") {
          return _this.tableDataCount[column.property] + "（" + _this.tableDataCount["keep_role_1_day_rate"] + "%）";
        }
        if (column.property == "watchers_count") {
          return _this.tableDataCount[column.property] + "（" + _this.tableDataCount["watch_video_rate"] + "%）";
        }
        if (column.property == "new_watchers_count") {
          return _this.tableDataCount[column.property] + "（" + _this.tableDataCount["new_watch_video_rate"] + "%）";
        }
        if (column.property == "old_watchers_count") {
          return _this.tableDataCount[column.property] + "（" + _this.tableDataCount["old_watch_video_rate"] + "%）";
        }
        if (column.property == "win_rate") {
          return _this.tableDataCount[column.property] + "%";
        }
        if (column.property == "new_win_rate_1") {
          return _this.tableDataCount[column.property] + "%";
        }
        if (column.property == "new_win_rate_2") {
          return _this.tableDataCount[column.property] + "%";
        }
        return _this.tableDataCount[column.property];
      })];
    },
    checkColumnMethod: function checkColumnMethod(_ref4) {
      var column = _ref4.column;
      if (column.property === "date_str") {
        return false;
      }
      return true;
    }
  }
};